import React from 'react'
import { Query } from 'react-apollo'
import _ from 'lodash'
import { Tooltip } from 'antd'
import { Icon, Div, Loading } from 'konsys-ui'
import { ChevronsUpDown } from 'lucide-react'
import { TRUCK_TYPE, GET_FLEETS } from '../../../constants/graphql/query'
import {
  InputWithPlaceHolder, StatusSelector, ActionSelector, HeaderLabel, CellText, DropdownSelector, StatusCell,
} from '../../../components/truck-components'
import { theme } from '../../../styles/_variables'
import { ownerTypes, ownerTypesObj } from '../constants'

const { color } = theme
const convertTruckType = (value) => {
  switch (value) {
    case ownerTypesObj.PADOONGRICH:
      return ownerTypesObj.PADOONGRICH_TH
    case ownerTypesObj.JOINTCAR:
      return ownerTypesObj.JOINTCAR_TH
    case ownerTypesObj.OUTJOINTCAR:
      return ownerTypesObj.OUTJOINTCAR_TH
    default:
      return 'ไม่ระบุ'
  }
}

export default {
  columns: [{
    Header: () => (
      <Div display='flex' justifyContent='space-between' alignItems='center'>
        <HeaderLabel>
          ทะเบียนหัว <ChevronsUpDown color={color.coolGrey} />
        </HeaderLabel>
      </Div>
    ),
    accessor: 'plateNumber',
    sortable: true,
    filterable: true,
    Cell: props => <CellText>{props.value}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.plateNumber, filter.value),
    width: 150,
  }, {
    Header: <HeaderLabel>พนักงานประจำ</HeaderLabel>,
    accessor: 'driver.fullname',
    sortable: false,
    filterable: true,
    Cell: props => <Tooltip placement="top" title={props.value}><CellText>{props.value}</CellText></Tooltip>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.d, filter.value),
    width: 180,
  }, {
    Header: () => <HeaderLabel>Fleet</HeaderLabel>,
    accessor: 'fleet',
    sortable: false,
    filterable: true,
    Cell: props => <Tooltip placement="top" title={props.value}><CellText>{props.value}</CellText></Tooltip>,
    // Filter: ({ onChange }) => <DropdownSelector key='filter' data={fleetData} handleChange={e => onChange(e)} filter={true} statusAttr='ทั้งหมด' />,
    Filter: ({ onChange }) => <Query
      query={GET_FLEETS}
    >
     { ({ error, loading, data }) => {
       if (error) return <p>เกิดข้อผิดพลาด</p>
       if (loading && _.isEmpty(data)) return <Loading center='true' />
       let newArr = [{ value: 'ALL', text: 'ทั้งหมด' }]

       newArr = _.concat(newArr, data.FleetList.lists.map(v => (
         { value: v.name, text: v.name }
       )))
       return (
          <DropdownSelector
            key='filter'
            data={newArr}
            handleChange={e => onChange(e)}
            filter={true}
            statusAttr='ทั้งหมด'
            typeNameTh={true}
          />
       )
     }}
    </Query>,
    filterMethod: (filter, row) => _.includes(row.fleet, filter.value),
    width: 130,
  }, {
    Header: <HeaderLabel>ชนิดรถ</HeaderLabel>,
    accessor: 'type.nameTh',
    sortable: false,
    filterable: true,
    Cell: props => <Tooltip placement="top" title={props.value}><CellText>{props.value}</CellText></Tooltip>,
    // Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    Filter: ({ onChange }) => <Query
      query={TRUCK_TYPE}
    >
     { ({ error, loading, data }) => {
       if (error) return <p>เกิดข้อผิดพลาด</p>
       if (loading && _.isEmpty(data)) return <Loading center='true' />
       let newArr = [{ value: 'ALL', text: 'ทั้งหมด' }]
       newArr = _.concat(newArr, data.TruckTypes.lists.map(v => (
         { value: v.nameTh, text: v.nameTh }
       )))
       return (
          <DropdownSelector
            key='filter'
            data={newArr}
            handleChange={e => onChange(e)}
            filter={true}
            statusAttr='ทั้งหมด'
            typeNameTh={true}
          />
       )
     }}
    </Query>,
    filterMethod: (filter, row) => _.includes(row.t, filter.value),
    width: 140,
  }, {
    Header: <HeaderLabel>เจ้าของรถ</HeaderLabel>,
    accessor: 'owner.nameTh',
    sortable: false,
    filterable: false,
    Cell: props => <CellText>{props.value}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.t, filter.value),
    width: 200,
  }, {
    Header: <HeaderLabel>ประเภทรถ</HeaderLabel>,
    accessor: 'owner.type',
    sortable: false,
    filterable: true,
    Cell: props => <CellText>{convertTruckType(props.value)}</CellText>,
    // Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    Filter: ({ onChange }) => <DropdownSelector
      key='filter'
      data={ownerTypes}
      handleChange={e => onChange(e)}
      filter={true}
      statusAttr='ทั้งหมด'
      typeNameTh={true}
    />,
    filterMethod: (filter, row) => _.includes(row.t, filter.value),
    width: 140,
  }, {
    Header: <HeaderLabel>สถานะ</HeaderLabel>,
    accessor: 'status',
    sortable: false,
    filterable: true,
    Cell: props => <StatusCell props={props} key={props.original.id} refetch={() => props.tdProps.rest.refetch()}/>,
    filterMethod: (filter, row) => filter.value === row.status || filter.value === 'ALL',
    Filter: ({ onChange }) => <StatusSelector key='selectstatus' statusAttr='ทั้งหมด' handleChange={e => onChange(e)} filter={true} />,
    width: 140,
  }, {
    Header: null,
    accessor: 'action',
    sortable: false,
    filterable: false,
    Cell: props => <ActionSelector props={props} />,
    width: 150,
  }],
}
